export enum IdentificationType {
    unknown = 'unknown',
    identityCard = 'identity card',
    passport = 'passport',
    residencePermit = 'residence permit',
}
